import React, { Component, Fragment } from 'react';
import isEmpty from 'lodash/isEmpty';
import { Modal } from 'reactstrap';

import config from '../../config';
import DayTabs from './DayTabs';
import DayTrail from './DayTrail';
import DaySummary from './DaySummary';
import Loading from '../../components/Loading';
import ServiceModal from './ServiceModal';
import EditNotifications from './EditNotifications';
import { EditableSliderForDay } from './ThemesModal/EditableSliderForDay';
import { EditableSliderForServiceModal } from './ThemesModal/EditableSliderForServiceModal';
import DateModal from './DateModal';

import TrailDescription from './TrailDescription';

import moment from 'moment';
import Page from '../../components/Page';
import TrekOverview from '../Trek/TrekOverview';
import { appendHoneyGuide } from '../../lib/utils';

import './DayDetail.css';

// import { deleteScriptsData, } from '../../lib/injectInitialData';

const modals = {
  dayModal: EditableSliderForDay,
  serviceModal: EditableSliderForServiceModal,
  none: '',
};

type Props = {
  id: string,
  getSelectedTrekById: Function,
};

export default class TrekDay extends Component<Props> {
  state = {
    dayDateModalIsOpen: false,
  };
  componentDidMount() {
    this.init();

    window.addEventListener('storage', this.reload);
  }

  reload = e => {
    const hasLodgeInDayChanged = localStorage.getItem('refreshDay') === '1';
    if (hasLodgeInDayChanged) {
      localStorage.removeItem('refreshDay');
      window.location.reload();
    }
  };

  componentDidUpdate(prevProps) {
    const { id, day, getDayData, isLoggedIn } = this.props;

    if (prevProps.day !== day) getDayData({ id, day });

    if (prevProps.id !== id) this.init();

    if (prevProps.isLoggedIn !== isLoggedIn) this.init();
  }

  init = () => {
    const { id, day, getSelectedTrekById, getDayData, data } = this.props;

    getSelectedTrekById({ id });
    if (!data) getDayData({ id, day });
  };

  componentWillUnmount() {
    this.props.refreshDayData();
    window.removeEventListener('storage', this.reload);
  }

  overrideTags(tags) {
    if (tags) {
      return {
        ...tags,
        canonicalUrl: tags.canonicalUrl
          ? tags.canonicalUrl
          : `${config.appUrl}${this.props.url}`,
      };
    }
  }

  render() {
    const {
      id,
      day,
      // url,
      name,
      region,
      noOfDays,
      data,
      dataInfo,
      uiInfo,
      addToDay,
      setServiceModalConfig,
      clearServiceModalConfig,
      changeServiceModalTheme,
      toggleServicesModal,
      toggleDayEditModal,
      openSlider,
      trek,
    } = this.props;
    const dayDate = data && data.date ? moment(data.date).format('YYYY-MM-DD') : '';
    const ModalToOpenInDay = modals[uiInfo.modalType];
    const editingPatchInfoId = dataInfo.patchInfo && dataInfo.patchInfo.segmentId;
    let flightInfoInSummary = [];
    let lodgeInfoInSummary = [];
    let isFirst = false;
    const defaultIndexFlight = 1;
    const defaultIndexLodge = data && data.routes.length - 1;
    isFirst = data && data.routes.length === 1;

    let patchInfoLodge =
      data && this.resolvePatchInfo(data.routes[defaultIndexLodge], defaultIndexLodge);
    let patchInfoFlight = data
      ? !isFirst
        ? this.resolvePatchInfo(data.routes[defaultIndexFlight], defaultIndexFlight)
        : {}
      : {};

    data &&
      data.routes.map((route, i) =>
        route.posters.filter(poster => {
          if (poster.poster_type === 'flights') {
            flightInfoInSummary.push(poster);
            patchInfoFlight = this.resolvePatchInfo(route, i);
          } else if (poster.poster_type === 'lodgings') {
            lodgeInfoInSummary.push(poster);
            patchInfoLodge = this.resolvePatchInfo(route, i);
          }
          return null;
        })
      );
    const lodgeAndFlightData = {
      lodgeInfoInSummary,
      patchInfoLodge,
      flightInfoInSummary,
      patchInfoFlight,
      isFirst,
    };

    const titleName = trek && `Day ${day} of ${trek.name}`;

    const tagsForSeo = {
      ...this.overrideTags(TrekOverview.getTagsForSEO(this.props)),
    };

    return (
      <Page {...tagsForSeo} title={appendHoneyGuide(titleName)}>
        <div className="no-gutters">
          <DayTabs
            active={day}
            name={name}
            id={id}
            numberOfDays={noOfDays}
            region={region}
          />
          {data ? (
            <Fragment>
              <div className="container day-by-day">
                <DaySummary
                  places={data.places}
                  date={dayDate}
                  data={lodgeAndFlightData}
                  modalType={'trekDaySummary'}
                  toggle={this.toggleDateModal}
                  roomType={data.room_type}
                  region={dataInfo.selectedTrekRegion}
                />
                {!isEmpty(data.trail_descriptions) && (
                  <TrailDescription desc={data.trail_descriptions} />
                )}
                <div className="white-panel">
                  <h2>DAY HIGHLIGHTS</h2>
                  <ul className="timeline">
                    {data.routes.map((route, i) => {
                      const patchInfo = this.resolvePatchInfo(route, i);
                      return (
                        <DayTrail
                          key={route.segment_id}
                          first={isFirst}
                          route={route}
                          patchInfo={patchInfo}
                          editingPatchInfoId={editingPatchInfoId}
                          setServiceModalConfig={setServiceModalConfig}
                          openSlider={openSlider}
                          date={dayDate}
                          region={dataInfo.selectedTrekRegion}
                        />
                      );
                    })}
                  </ul>
                </div>
              </div>
              <Modal
                isOpen={uiInfo.cardsModalIsOpen}
                toggle={this.toggleCardsModal}
                className="place-modal"
                style={{ maxWidth: '600px' }}
              >
                <ModalToOpenInDay placeId={dataInfo.placeId} modalType={uiInfo.modalType} />
              </Modal>
              <Modal
                isOpen={uiInfo.serviceModalIsOpen}
                toggle={toggleServicesModal}
                className="service-modal"
                style={{ maxWidth: '991px' }}
              >
                <ServiceModal
                  patchInfo={dataInfo.patchInfo}
                  theme={uiInfo.theme}
                  route={dataInfo.route}
                  date={dayDate}
                  routeLength={dataInfo.routeLength}
                  toggle={toggleServicesModal}
                  addToDay={addToDay}
                  clearServiceModalConfig={clearServiceModalConfig}
                  changeServiceModalTheme={changeServiceModalTheme}
                />
              </Modal>
              <Modal
                isOpen={uiInfo.dayEditModalIsOpen}
                toggle={toggleDayEditModal}
                className="notification-modal"
                style={{ maxWidth: '500px' }}
              >
                <EditNotifications toggle={toggleDayEditModal} />
              </Modal>
              <Modal isOpen={this.state.dayDateModalIsOpen} className="before-buy">
                <DateModal
                  toggle={this.toggleDateModal}
                  handleContinue={this.handleContinue}
                />
              </Modal>
              {/* )} */}
            </Fragment>
          ) : (
            <Loading size="small" />
          )}
        </div>
      </Page>
    );
  }

  toggleDateModal = () =>
    this.setState({ dayDateModalIsOpen: !this.state.dayDateModalIsOpen });

  handleContinue = () => {
    this.toggleDateModal();
    window.location.reload();
  };

  resolvePlaceId = segment => {
    const id = segment.segment_id.split('-');
    const name = segment.name.split('-');
    if (segment.segment_type === 'point') {
      return {
        placeId: id[1],
        placeName: name[0],
      };
    } else if (segment.segment_type === 'path') {
      return {
        placeId: `${id[1]},${id[2]}`,
        placeName: `${name[0]} - ${name[1]}`,
      };
    }
  };

  resolvePatchInfo = (route, index) => {
    const { id, day, name } = this.props;
    const { placeId, placeName } = this.resolvePlaceId(route);
    const patchInfo = {
      index,
      dayNo: day,
      trekId: id,
      trekName: name,
      placeId: placeId,
      placeName: placeName,
      segmentId: route.segment_id,
    };
    return patchInfo;
  };

  toggleCardsModal = () => {
    const { uiInfo } = this.props;
    const newModalState = !uiInfo.cardsModalIsOpen;
    this.props.toggleModal({ newModalState });
  };
}



// WEBPACK FOOTER //
// ./src/screens/Trek/TrekDay.js